import Model from './model.js';

export default class Admin extends Model
{
    constructor(id, name, description, username, password, type, active, roles, permissions, categories, personTypes, regions, personTypeOperations, categoryPersonTypeOperations, createdAt = null, updatedAt = null){
        super()
        this.id         = id ?? 0
        this.name       = name
        this.description= description
        this.username   = username
        this.password   = password
        this.type       = type
        this.active     = active
        this.createdAt  = createdAt
        this.updatedAt  = updatedAt

        // Related Data to Admin
        this.roles                          = []
        this.permissions                    = []
        this.categories                     = []
        this.personTypes                    = []
        this.regions                        = []
        this.personTypeOperations           = []
        this.categoryPersonTypeOperations   = []

        this.init()
    }

    setRoles(roles){
        this.roles = roles
        return this
    }

    setPermissions(permissions){
        this.permissions = permissions
        return this
    }

    setCategories(categories){
        this.categories = categories
        return this
    }

    setPersonTypes(personTypes){
        this.personTypes = personTypes
        return this
    }

    setRegions(regions){
        this.regions = regions
        return this
    }

    setPersonTypeOperations(personTypeOperations){
        this.personTypeOperations = personTypeOperations
        return this
    }

    setCategoryPersonTypeOperations(categoryPersonTypeOperations){
        this.categoryPersonTypeOperations = categoryPersonTypeOperations
        return this
    }

    mapToUpdate(){
        return {
            personName: this.name ?? null,
            username: this.username ?? null,
            description: this.description ?? null,
            active: this.active?.value ?? null,
            type: this.type?.value ?? null,
            regionIds: this.regions ?? [],
            categoryIds: this.categories ?? [],
            personTypeIds: this.personTypes ?? [],
            roleIds: this.roles ?? [],
            permissionIds: this.permissions ?? [],
            personTypeOperations: this.personTypeOperations ?? [],
            categoryPersonTypeOperations: this.categoryPersonTypeOperations ?? [],
        }
    }

    mapToCreate(){
        let formDate = this.mapToUpdate();
        formDate.password = this.password ?? null;
        return formDate;
    }
}

